export const photoCaptureUpdateContextRequestReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isContextUpdated: false });
};
//# sourceMappingURL=photoCaptureUpdateContextRequestReducer.js.map